import { useLoaderData } from "react-router-dom";
import { ReactElement } from "react";

/**
 * Passthrough route component that renders the React element returned by the
 * matched route's loader. React Router has no built-in for "render the loader's
 * element", so this one-line component is the minimal idiom: the login route's
 * loader redirects on success (element never mounts) or returns an element to
 * render on failure.
 */
export const LoaderElement = () => useLoaderData() as ReactElement;
